export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">
                随时随地 · 畅读漫画
              </span>
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">漫画阅读APP</h2>
              <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6 max-w-lg">
                下载<strong>土豪漫画网</strong>移动客户端，随时随地畅享<strong>韩漫推荐</strong>、<strong>日漫大全</strong>与<strong>国漫排行榜</strong>的精彩内容。
                离线缓存、夜间模式、智能推荐，更流畅的移动阅读体验等你来发现。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-full cursor-pointer hover:bg-background-100 transition-all">
                  <i className="ri-apple-fill text-xl text-foreground-800"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">Download on</div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-full cursor-pointer hover:bg-background-100 transition-all">
                  <i className="ri-google-play-fill text-xl text-foreground-800"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">Get it on</div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">Google Play</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative">
                <div className="absolute -inset-4 bg-background-50/10 rounded-3xl blur-2xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Manga%20reading%20app%20on%20smartphone%20mockup%20with%20warm%20color%20comic%20screens%2C%20clean%20minimal%20UI%20design%2C%20Japanese%20manga%20page%20displayed%20on%20phone%20screen%2C%20soft%20cream%20background%2C%20modern%20mobile%20app%20presentation%2C%20editorial%20quality&width=500&height=600&seq=app-mockup-01&orientation=portrait"
                  alt="土豪漫画网APP移动端"
                  title="土豪漫画网 - 移动端漫画阅读APP"
                  className="relative w-[220px] md:w-[260px] h-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}